__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-maps-travelers-cheques-root'].baseUrl;
import ModuleContainer from './components/AxpMapsTravelersChequesRoot';
import './iguazu-rest/config';
import './iguazu-rpc/config';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    'iguazu': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.2.0',
      module: require('iguazu')
    },
    'iguazu-holocron': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.8.2',
      module: require('iguazu-holocron')
    },
    'iguazu-rest': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.11.1',
      module: require('iguazu-rest')
    },
    'iguazu-rpc': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.6.1',
      module: require('iguazu-rpc')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'axp-maps-travelers-cheques-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'axp-maps-travelers-cheques-root';
}